import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';
import ReactSelect from 'react-select';

const Index = () => {


    let userDataRole = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).roleId : {};
    let userDataBusinessId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).businessId : {};


    const context = useContext(Context);
    const { readData } = useEntityCrud('Service/GetAllServiceDelivery');
    const { addData: updateData } = useEntityCrud('Business/changeDeliverAgentStatus');
    const { readData: searchDeliveries } = useEntityCrud('Business/getDeliverAgents');
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')

    const [rows, setRows] = useState([]);

    const [businessId, setBuisnessId] = useState(0);
    const [nationalCode, setNationalCode] = useState("");
    const [dataFound, setDataFound] = useState(false);


    const [businessList, setBusinessList] = useState([]);
    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
    }, [])


    const getData = () => {
        const postedData = {
            "businessId": localStorage.getItem('businessIdDelivery'),
        }
        searchDeliveries(postedData).then(({ data }) => {
            if (data.status) {
                setDataFound(true)
                setRows(data.result)
            }
            else {
                toast.error(data.message)
                setRows({})
            }
        })
    }


    useEffect(() => {
        if (userDataRole === 1 && (localStorage.getItem('businessIdDelivery'))) {
            getData();
            setBuisnessId({ value: localStorage.getItem('businessIdDelivery'), label: localStorage.getItem('businessTitle') })
        }
    }, []);


    const deActiveRow = id => {
        const postedData = {
            id,
            isActive: false
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت پیک مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                toast.error(data.message);
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            isActive: true
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت پیک مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                toast.error(data.message);
        });
    }


    const searchDelivery = () => {
        setDataFound(true)
        const postedData = {
            "businessId": businessId.value,
            /*      "person": {
                     "nationalCode": nationalCode
                 } */
        }
        searchDeliveries(postedData).then(({ data }) => {
            if (data.status) {
                setRows(data.result)
                const businessTitle = businessAll?.find(it => it.value === (data.result[0].businessId))?.label
                window.localStorage.setItem("nationalCodeDelivery", data.result[0].person.nationalCode)
                window.localStorage.setItem("businessTitle", businessTitle)
                window.localStorage.setItem("businessIdDelivery", businessId.value)
            }
            else {
                toast.error(data.message)
                setRows({})
            }
        })
    }

    useEffect(() => {
        if (userDataRole === 3) {
            setDataFound(true)
            const postedData = {
                "businessId": userDataBusinessId[0],
            }
            searchDeliveries(postedData).then(({ data }) => {
                if (data.status) {
                    setRows(data.result)
                    const businessTitle = businessAll?.find(it => it.value === (data.result[0].businessId || userDataBusinessId[0]))?.label
                    window.localStorage.setItem("businessIdDelivery", businessId.value || userDataBusinessId[0])
                    window.localStorage.setItem("businessTitle", businessTitle)
                }
                else {
                    toast.error(data.message)
                    setRows({})
                }
            })
        }
    }, []);



    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">پیک</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد پیک جدید</Link> : ''}
                {context.checkHasPermission('create') ? <hr /> : ''}

                {userDataRole === 1 && <div class="alert alert-info" role="alert">
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                    <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                    جهت نمایش  پیک مورد نظر لطفا کسب و کار  را انتخاب کنید.
                </div>}


                {userDataRole === 1 && <div className="row ">
                    <div className="col-md-3">
                        <label>
                            کسب و کار
                        </label>
                        <ReactSelect label="   کسب و کار"
                            options={businessAll.filter(item => item.isActive === true)}
                            value={businessAll.length === 1 ? businessAll[0] : businessId}
                            onChange={(value) => {
                                localStorage.removeItem("businessIdDelivery")
                                localStorage.removeItem("nationalCodeDelivery")
                                localStorage.removeItem("businessTitle")
                                setBuisnessId(value)
                            }}
                            placeholder="انتخاب کنید"
                            name="buisnessId"
                        />
                    </div>

                    <div className="col-md-3 mt-4">
                        <button type="button"
                            disabled={(businessId !== 0) ? false : true}
                            class="btn btn-primary mt-3" onClick={() => searchDelivery()}>جستجو</button>
                    </div>

                </div>}

                {dataFound &&
                    <>
                        {rows.length > 0 ? <table className="table table-bordered table-hover border text-nowrap text-md-nowrap mt-4">
                            <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>کسب و کار</th>
                                    <th>شماره پلاک</th>
                                    <th>نام و نام خانوادگی</th>
                                    <th>کد ملی</th>
                                    <th>  وضعیت </th>
                                    <th>  عملیات </th>
                                </tr>
                            </thead>
                            <tbody>l
                                {rows?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{businessAll?.find(it => it.value === item.businessId)?.label}</td>
                                        <td>{item.vehicleNo}</td>
                                        <td>{item.person.name + " " + item.person.lastName}</td>
                                        <td>{item.person.nationalCode}</td>
                                        {/*                                 <td>{item.person.cellphone}</td>
 */}                            <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>

                                        <td className="btn-list">
                                            {context.checkHasPermission('update') ? <Link to={'update/' + item.id + '/' + item.person.nationalCode} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                            {(item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>)}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table> :
                            <div className='alert alert-info my-4'>
                                پیکی یافت نشد.
                            </div>
                        }
                    </>
                }
            </div>
        </div>
    );
}

export default Index;